/**
 * Handles authentication redirects for API responses
 * This function checks if the API response indicates that the user needs to be redirected to login
 */
const followIfLoginRedirect = (response: Response): void => {
  // Check if the response indicates authentication is required
  if (response.status === 401) {
    // Store the current path to redirect back after login
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== '/login') {
      sessionStorage.setItem('redirectAfterLogin', currentPath);
    }

    // Redirect to login page using React Router
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    return;
  }

  // Check for forbidden (403) - user is authenticated but not authorized
  if (response.status === 403) {
    console.warn('Access forbidden - insufficient permissions');
    return;
  }

  // Check for explicit redirect responses (server-side redirects)
  if (response.status >= 300 && response.status < 400) {
    const location = response.headers.get('Location');
    if (location && (location.includes('/Identity/Account/Login') || location.includes('/login'))) {
      // Redirect to our SPA login page instead of server login
      window.location.href = '/login';
    }
  }
};

export default followIfLoginRedirect;